import { render, staticRenderFns } from "./DatepickerBase.vue?vue&type=template&id=0a273d3a&scoped=true&"
import script from "./DatepickerBase.vue?vue&type=script&lang=js&"
export * from "./DatepickerBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a273d3a",
  null
  
)

export default component.exports